<template>
    <v-card>
        <v-card-title>Add Remark</v-card-title>
        <v-divider />
        <v-card-text class="mt-4">
            <span>
                Enter your remark below and click OK to add it to the issue. Your name
                and the current time will automatically be added to your remark.
            </span>
            <v-textarea class="mt-4" color="#c42111" no-resize outlined rows="5" v-model="remark">
            </v-textarea>
        </v-card-text>
        <v-divider />
        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text @click="$emit('ok', remark)">Ok</v-btn>
            <v-btn text @click="$emit('cancel')">Cancel</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: 'AddRemark',
    props: [],
    components: {
    },
    data: () => ({
        remark: '',
    }),

    computed: {
    },

    methods: {

    },

    watch: {
    },

    mounted() {

    },


};
</script>

<style scoped>

</style>

